import { Warning } from '../../../assets/icons'
import { SVGWrapper, HelpIcon, TooltipText } from '../../../components'
import { Section } from '../styles'

const LumpSumPensionExpected = () => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        Have you received the lump sum pension payout yet? Our projections assume you invest it for
        future retirement expenses. Update your payout status.&nbsp;
        <HelpIcon tooltip={TooltipText.lumpSumPensionPayout()} />
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}
export default LumpSumPensionExpected
